import { render, staticRenderFns } from "./ApprovalTemplateLibrary.vue?vue&type=template&id=164cec41&scoped=true&"
import script from "./ApprovalTemplateLibrary.vue?vue&type=script&lang=js&"
export * from "./ApprovalTemplateLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalTemplateLibrary.vue?vue&type=style&index=0&id=164cec41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164cec41",
  null
  
)

export default component.exports